define('collection/ProviderCollection',['require','lib/collection/FilterableCollection','model/ProviderModel'],function (require) {
	
	var FilterableCollection = require('lib/collection/FilterableCollection');
	var ProviderModel = require('model/ProviderModel');
	
	/**
	 * Providers list collection
	 * 
	 * @class ProviderCollection
	 */
	return FilterableCollection.extend({
		
		url: '/provider/',
		model: ProviderModel
		
	});
	
});
